var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    focusable: "false",
    width: "1em",
    height: "1em",
    style: {
      msTransform: "rotate(360deg)",
      WebkitTransform: "rotate(360deg)",
      transform: "rotate(360deg)"
    },
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M472 96h-88V40h-32v56H160V40h-32v56H40a24.028 24.028 0 0 0-24 24v336a24.028 24.028 0 0 0 24 24h432a24.028 24.028 0 0 0 24-24V120a24.028 24.028 0 0 0-24-24zm-8 352H48V128h80v40h32v-40h192v40h32v-40h80z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M112 224h32v32h-32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M200 224h32v32h-32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M280 224h32v32h-32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M368 224h32v32h-32z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M112 296h32v32h-32z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M200 296h32v32h-32z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M280 296h32v32h-32z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M368 296h32v32h-32z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M112 368h32v32h-32z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M200 368h32v32h-32z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M280 368h32v32h-32z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M368 368h32v32h-32z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 512,
    height: 512,
    fill: "rgba(0, 0, 0, 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWhite);
export default __webpack_public_path__ + "static/media/calendar_white.99bde3b1cff0ee9118eedbf0eb6537be.svg";
export { ForwardRef as ReactComponent };